import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import OpenerImage from '../common/opener_image';
import OpenerImagesPropTypes from '../../utils/prop-types/OpenerImagesPropTypes';
import { sendAnalyticsEvent } from '../../utils/analytics';

export default class VideoCard extends PureComponent {
  handleClick = () => {
    sendAnalyticsEvent(
      'Trending Videos',
      'Click',
      this.props.path
    );
  }

  render() {
    const { label, path, opener_images, truncated_title_62, rowType } = this.props;
    return (
      <Link to={path} onClick={this.handleClick} className="video-card">
        <OpenerImage
          rowType={rowType}
          opener_images={opener_images}
        />
        <figure className="icon-video" />
        <div className="story-content">
          <div className="label" dangerouslySetInnerHTML={{ __html: label }} />
          <div className="title">
            <span dangerouslySetInnerHTML={{ __html: truncated_title_62 }} />
          </div>
        </div>
      </Link>
    );
  }
}

VideoCard.propTypes = {
  label: PropTypes.string.isRequired,
  truncated_title_62: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  opener_images: OpenerImagesPropTypes.isRequired,
  rowType: PropTypes.string.isRequired,
  indexWithinRow: PropTypes.number.isRequired
};
